import { Container } from "reactstrap";
import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";
import MainDetail from "../../commonComponents/productDetail/mainDetail";

const CarThumbnailSliderContainer = () => {
  return (
    <>
      <CarBreadcrumb type="car_thumbnail_slider" />
      <div className="car-detail-section half-breadcrumbs">
        <Container>
          <MainDetail type="car" />
        </Container>
      </div>
      <CarDetail type="car" />
    </>
  );
};

export default CarThumbnailSliderContainer;
